import { ChanneltalkImportTemplate } from '@/features/Setting/Integrations/providers/Channeltalk/constants';
import type {
  ChanneltalkInfo,
  ImportRuleT,
} from '@/features/Setting/Integrations/providers/types';
import { defaultAxios } from '@/services/index';

import { processImportRuleParam } from '../util';

const channeltalkService = {
  async createChannelInfo(
    access_key: string,
    access_secret: string,
    workspaceAlias: string,
  ): Promise<ChanneltalkInfo> {
    const res = await defaultAxios.post(
      `/workspaces/${workspaceAlias}/channeltalk/credential`,
      { access_key, access_secret },
    );
    return res.data;
  },
  async getChannelInfo(workspaceAlias: string): Promise<ChanneltalkInfo[]> {
    const res = await defaultAxios.get(
      `/workspaces/${workspaceAlias}/channeltalk/`,
    );
    return res.data;
  },
  async importChannelFeedback(alias: string, dateRange: NullableDateRangeT) {
    const res = await defaultAxios.post(`/channeltalk/${alias}/import`, {
      start_date: dateRange.start_date,
      end_date: dateRange.end_date,
    });
    return res.data;
  },
  async deleteChannelInfo(channelAlias: string) {
    try {
      await defaultAxios.delete(`/channeltalk/${channelAlias}`);
      return true;
    } catch (e) {
      return false;
    }
  },
  async updateChanneltalkImportUserOption(alias: string, privacy: boolean) {
    try {
      const res = await defaultAxios.patch(`/channeltalk/${alias}/privacy`, {
        privacy_policy: privacy,
      });
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async updateChanneltalkTitleOption(alias: string, status: boolean) {
    try {
      const res = await defaultAxios.patch(
        `/channeltalk/${alias}/desc_to_title`,
        {
          desc_to_title: status,
        },
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
  async updateChanneltalkImportOption(alias: string, importRule: ImportRuleT) {
    try {
      const processedImportRule = processImportRuleParam(
        importRule,
        ChanneltalkImportTemplate,
      );
      const res = await defaultAxios.patch(
        `/channeltalk/${alias}/trigger`,
        processedImportRule,
      );
      return res.data;
    } catch (e) {
      return false;
    }
  },
};

export default channeltalkService;
